import Vue from 'vue'
import App from './App.vue'
import { rtdbPlugin } from 'vuefire'
import './firebase'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faLock, faLockOpen, faTimes, faCog } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faTrashAlt)
library.add(faLock)
library.add(faLockOpen)
library.add(faTimes)
library.add(faCog)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(rtdbPlugin);
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
